"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var text_1 = require("../text");
var formatNumberSuffix = function (numberAndSuffix) {
    return numberAndSuffix
        .toLowerCase()
        .replace(/\b1(ere|er|e)\b/g, '1re') // Uniformize number suffix: 1ere, 1er, 1e => 1re
        .replace(/\d(eme)\b/g, function (captured) { return captured.replace('eme', 'e'); });
}; // Uniformize number suffix: 2eme, 3eme... => 2e, 3e...
var cleanJuridictionRoom = function (dirty) {
    if (!dirty)
        return dirty;
    return (0, text_1.normalize)(dirty, 'upper')
        .replace(',', '')
        .replace(/\d+[a-zA-Z]+/g, formatNumberSuffix) // Format number suffix
        .replace(/1re (BUREAU|CABINET|PRESIDENT)/g, function (captured) { return captured.replace('re', 'er'); }); // Few exceptions with er
};
exports.default = cleanJuridictionRoom;
//# sourceMappingURL=cleanJuridictionRoom.js.map